import { Input, RadioGroup, RadioItem, Spinner } from '@platform/components';
import { AssignmentDeclinedReason, SimplifiedUserRole } from '@platform/client/schemas';

type MatchDecliningContentProps = {
  setDeclineReason: (reason: AssignmentDeclinedReason) => void;
  setAdditionalDetails: (details: string) => void;
  declineReason: AssignmentDeclinedReason | undefined;
  additionalDetails: string;
  isSaving: boolean;
  userAccountType: SimplifiedUserRole;
};

const proDecliningReasons: RadioItem[] = [
  {
    value: AssignmentDeclinedReason.choosing_different_org,
    title: "I'm choosing a different organization",
  },
  {
    value: AssignmentDeclinedReason.wrong_skills,
    title: "I don't have the right skills",
  },
  {
    value: AssignmentDeclinedReason.timezone_or_availability,
    title: 'Timezone or availability reasons',
  },
  {
    value: AssignmentDeclinedReason.other,
    title: 'Other',
  },
];

const orgRepDecliningReasons: RadioItem[] = [
  {
    value: AssignmentDeclinedReason.choosing_different_org,
    title: "I'm choosing a different Experteer",
  },
  {
    value: AssignmentDeclinedReason.wrong_skills,
    title: "They don't have the right skills",
  },
  {
    value: AssignmentDeclinedReason.project_no_longer_fits,
    title: 'This project no longer fits my needs',
  },
  {
    value: AssignmentDeclinedReason.timezone_or_availability,
    title: 'Timezone or availability reasons',
  },
  {
    value: AssignmentDeclinedReason.other,
    title: 'Other',
  },
];

export const MatchDecliningContent = (props: MatchDecliningContentProps) => {
  const {
    setDeclineReason,
    setAdditionalDetails,
    declineReason,
    additionalDetails,
    isSaving,
    userAccountType,
  } = {
    ...props,
  };

  const validateRadio = (value: string | number | null): string | undefined => {
    if (!value) {
      return 'Select one option to continue';
    }
  };

  return (
    <div className='flex flex-col gap-8 md:mt-8 items-stretch md:w-[500px]'>
      {isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-xl'>Can you tell us why this wasn't a good fit?</div>
          <div className='mt-4'>
            {/* TODO: Handle the org rep case */}
            <RadioGroup
              name='decline-reason'
              aria-label='decline-reason'
              items={
                userAccountType === SimplifiedUserRole.PROFESSIONAL ?
                  proDecliningReasons
                : orgRepDecliningReasons
              }
              onChange={(value) => {
                setDeclineReason(value as AssignmentDeclinedReason);
              }}
              validate={validateRadio}
            />
          </div>
          {declineReason === AssignmentDeclinedReason.other && (
            <div className='mt-4'>
              <div className='text-sm'>Additional Details</div>
              <Input
                type='multiline'
                required={declineReason === AssignmentDeclinedReason.other}
                placeholder="Tell us more about why this wasn't a good fit..."
                onChange={(e) => {
                  setAdditionalDetails(e.target.value);
                }}
                value={additionalDetails}
                validate={(value: string) => {
                  if (!value?.length) {
                    return "To continue, tell us more about why this wasn't a good fit.";
                  }
                }}
              />
            </div>
          )}
        </>
      }
    </div>
  );
};
